var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "gen-page-content-wrapper" } }, [
    _c("div", { staticClass: "gen-main" }, [
      _c("nav", { staticClass: "gen-fixed-nav" }, [
        _c("div", { staticClass: "gen-user-info" }, [
          _c(
            "span",
            { staticClass: "gen-user-avatar" },
            [_c("fa", { attrs: { icon: ["fas", "user"] } })],
            1
          ),
          _vm._v(" "),
          _c("span", { staticClass: "gen-user-greeting" }, [
            _c("span", { staticClass: "gen-user-greeting-label" }, [
              _vm._v("Welcome back"),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "gen-user-greeting-name" }, [
              _vm._v(_vm._s(_vm.user ? _vm.user.name : "")),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "gen-nav-actions" }, [
          _vm.globalIsUserAllowed("Release_History")
            ? _c(
                "button",
                {
                  staticClass: "gen-nav-btn",
                  attrs: { title: "Release History" },
                  on: {
                    click: function ($event) {
                      return _vm.$bvModal.show("genericReleaseModal")
                    },
                  },
                },
                [_c("fa", { attrs: { icon: ["fas", "history"] } })],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.globalIsUserAllowed("Change_Password")
            ? _c(
                "button",
                {
                  staticClass: "gen-nav-btn",
                  attrs: {
                    disabled: _vm.isTestAccount,
                    title: _vm.isTestAccount
                      ? "Cannot change password of test account"
                      : "Change Password",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$bvModal.show("PTVChangePasswordModal")
                    },
                  },
                },
                [_c("fa", { attrs: { icon: ["fas", "key"] } })],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "gen-nav-btn gen-signout-btn",
              attrs: { title: "Sign Out" },
              on: { click: _vm.signOut },
            },
            [_c("fa", { attrs: { icon: ["fas", "sign-out-alt"] } })],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "container-fluid gen-dashboard-content",
          class: { "gen-content--map-max": _vm.mapFullscreen },
        },
        [
          _c(
            "div",
            { staticClass: "row gen-dashboard-section my-4 no-gutters" },
            [
              _c("div", { staticClass: "left-col pr-3" }, [
                _c("div", { staticClass: "chart-card mb-3" }, [
                  _c(
                    "div",
                    { staticClass: "chart-card-body d-flex flex-column" },
                    [
                      _c("div", { staticClass: "gen-card-header-row" }, [
                        _c(
                          "span",
                          { staticClass: "gen-card-header-icon" },
                          [_c("fa", { attrs: { icon: ["fas", "chart-bar"] } })],
                          1
                        ),
                        _vm._v(" "),
                        _c("h4", { staticClass: "gen-card-title-text" }, [
                          _vm._v("Mileage by Roadway Type"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "chart-container flex-grow-1" },
                        [
                          _c("apexchart", {
                            ref: "genericReleasesChart",
                            attrs: {
                              type: "bar",
                              width: "100%",
                              height: "100%",
                              options: _vm.chartOptions,
                              series: _vm.series,
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "releases-card mb-3" }, [
                  _c(
                    "div",
                    { staticClass: "releases-card-body d-flex flex-column" },
                    [
                      _c("div", { staticClass: "gen-card-header-row" }, [
                        _c(
                          "span",
                          { staticClass: "gen-card-header-icon" },
                          [_c("fa", { attrs: { icon: ["fas", "tag"] } })],
                          1
                        ),
                        _vm._v(" "),
                        _c("h4", { staticClass: "gen-card-title-text" }, [
                          _vm._v("Recent Releases"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("vue-good-table", {
                        staticClass: "releases-table",
                        attrs: {
                          id: "genericReleasesTable",
                          rows: _vm.rows,
                          columns: _vm.columns,
                          styleClass: "vgt-table modern-table",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "table-row",
                            fn: function (props) {
                              return [
                                props.column.field == "release_date"
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            new Date(
                                              props.row.release_date
                                            ).toLocaleDateString(_vm.language, {
                                              month: "2-digit",
                                              day: "2-digit",
                                              year: "numeric",
                                            })
                                          ) +
                                          "\n                  "
                                      ),
                                    ])
                                  : _c("span", [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            props.row[props.column.field]
                                          ) +
                                          "\n                  "
                                      ),
                                    ]),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "total-mileage-strip" },
                  _vm._l(_vm.regions, function (region) {
                    return _c(
                      "div",
                      { key: region.name, staticClass: "total-mileage-card" },
                      [
                        _c("div", { staticClass: "total-mileage-card-body" }, [
                          _c("span", { staticClass: "total-mileage-region" }, [
                            _vm._v(_vm._s(region.name)),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "total-mileage-display" }, [
                            _c("span", { staticClass: "total-mileage-value" }, [
                              _vm._v(_vm._s(region.count.toLocaleString())),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "total-mileage-unit" }, [
                              _vm._v("mi"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "total-mileage-label" }, [
                            _vm._v("Total Mileage"),
                          ]),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "right-col pl-3" }, [
                _c(
                  "div",
                  {
                    staticClass: "map-card h-100 w-100",
                    class: { "map-card--fullscreen": _vm.mapFullscreen },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "map-card-header d-flex justify-content-between align-items-center",
                      },
                      [
                        _c("div", { staticClass: "map-card-title" }, [
                          _c(
                            "span",
                            { staticClass: "map-card-title-icon" },
                            [_c("fa", { attrs: { icon: ["fas", "map"] } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "map-card-title-text" }, [
                            _vm._v("Map Overlays"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "map-fullscreen-btn",
                            attrs: {
                              title: _vm.mapFullscreen
                                ? "Minimize map"
                                : "Expand map",
                              "aria-label": _vm.mapFullscreen
                                ? "Minimize map"
                                : "Expand map",
                            },
                            on: { click: _vm.toggleMapFullscreen },
                          },
                          [
                            _c("fa", {
                              attrs: {
                                icon: [
                                  "fas",
                                  _vm.mapFullscreen
                                    ? "window-minimize"
                                    : "expand",
                                ],
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "map-body" }, [
                      _c("div", {
                        staticClass: "h-100 w-100",
                        attrs: { id: "vehiclesMap" },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "map-layer-panel",
                          class: {
                            "map-layer-panel--minimized":
                              _vm.layerPanelMinimized,
                          },
                        },
                        [
                          _c("div", { staticClass: "map-layer-panel-header" }, [
                            _c("h4", { staticClass: "map-layer-panel-title" }, [
                              _vm._v("Layers"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "map-layer-panel-minimize",
                                attrs: {
                                  "aria-expanded": !_vm.layerPanelMinimized,
                                  title: _vm.layerPanelMinimized
                                    ? "Expand layers"
                                    : "Minimize layers",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.layerPanelMinimized =
                                      !_vm.layerPanelMinimized
                                  },
                                },
                              },
                              [
                                _c("fa", {
                                  attrs: {
                                    icon: [
                                      "fas",
                                      _vm.layerPanelMinimized
                                        ? "chevron-up"
                                        : "chevron-down",
                                    ],
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          !_vm.layerPanelMinimized
                            ? [
                                _c(
                                  "draggable",
                                  {
                                    staticClass: "layer-toggle-list",
                                    attrs: {
                                      tag: "div",
                                      handle: ".layer-drag-handle",
                                    },
                                    model: {
                                      value: _vm.layerList,
                                      callback: function ($$v) {
                                        _vm.layerList = $$v
                                      },
                                      expression: "layerList",
                                    },
                                  },
                                  _vm._l(_vm.layerList, function (layer) {
                                    return _c(
                                      "div",
                                      {
                                        key: layer.name,
                                        staticClass: "layer-row",
                                      },
                                      [
                                        _c("fa", {
                                          staticClass: "layer-drag-handle",
                                          attrs: {
                                            icon: ["fas", "grip-vertical"],
                                            title: "Drag to reorder",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "layer-row-label" },
                                          [_vm._v(_vm._s(layer.display_name))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass: "layer-toggle-switch",
                                            class: { "is-on": layer.visible },
                                            attrs: {
                                              "aria-pressed": layer.visible,
                                              title: layer.visible
                                                ? "Hide layer"
                                                : "Show layer",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.$emit(
                                                  "toggle-layer",
                                                  layer.name
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("span", {
                                              staticClass: "layer-toggle-knob",
                                            }),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  }),
                                  0
                                ),
                                _vm._v(" "),
                                !_vm.layerList.length
                                  ? _c(
                                      "p",
                                      { staticClass: "text-muted mb-0" },
                                      [
                                        _vm._v(
                                          "\n                    No layers loaded yet.\n                  "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]),
                  ]
                ),
              ]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "gen-copyright" }, [
        _c(
          "a",
          {
            staticClass: "gen-attribution",
            attrs: { href: "https://dmp-maps.com/legal/", target: "_blank" },
          },
          [
            _vm._v(
              "\n        © " +
                _vm._s(new Date().getFullYear()) +
                " Dynamic Map Platform North America, Inc. All Rights Reserved\n      "
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }